export const extraordinaryPaymentHeaders = [
    {
        accessorKey: 'nombre',
        header: 'Nombre',
        enableEditing: false,
        size: 10,
        enableGlobalFilter: true
    },
    {
        accessorKey: 'modificado_por',
        header: 'Modificado por',
        enableEditing: false,
        enableGlobalFilter: false
    },
    {
        accessorKey: 'modificado',
        header: 'Fecha Modificada',
        enableEditing: false,
        enableGlobalFilter: true
    },
    {
        accessorKey: 'creado_por',
        header: 'Creado Por',
        enableEditing: false,
        enableGlobalFilter: false
    },
    {
        accessorKey: 'creado',
        header: 'Fecha Creado',
        enableEditing: false,
        enableGlobalFilter: false
    },
    {
        accessorKey: 'id',
        header: 'id',
        size: 10,
        enableEditing: false,
        enableGlobalFilter: true
    },
]